import { useEffect, useState } from "react";
import "./CookieConsent.css";

export default function CookieConsent() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem("cookie_consent");
        if (!consent) {
            const timer = setTimeout(() => setVisible(true), 1000);
            return () => clearTimeout(timer);
        }
    }, []);

    const acceptAll = () => {
        localStorage.setItem("cookie_consent", "all");
        setVisible(false);
        // Optional: initialize analytics, etc.
    };

    const acceptEssential = () => {
        localStorage.setItem("cookie_consent", "essential");
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div className="cookie-banner">
            <div className="cookie-text">
                <h4>Cookies & Datenschutz</h4>
                <p>
                    Ich verwende Cookies, um meine Website zu verbessern und dir ein optimales Erlebnis zu bieten.
                    <br />
                    Du kannst selbst entscheiden, welche Cookies du akzeptierst.
                </p>
                <a href="/datenschutz" className="cookie-link">Mehr erfahren</a>
            </div>
            <div className="cookie-buttons">
                <button onClick={acceptEssential} className="cookie-btn outline">
                    Nur notwendige
                </button>
                <button onClick={acceptAll} className="cookie-btn primary">
                    Alle akzeptieren
                </button>
            </div>
        </div>
    );
}
